import {RouteType} from "./config";
import RegistrationPage from "../pages/registration/Registration.page";
import RegistrationPontonPage from "../pages/registration/RegistrationPonton.page";
import RegistrationAccountsPage from "../pages/registration/RegistrationAccounts.page";
import RegistrationPageLayout from "../pages/registration/RegistrationPageLayout";
import {DeleteForeverTwoTone, EditNoteTwoTone, ManageAccountsTwoTone} from "@mui/icons-material";
import PortalPageLayout from "../pages/portal/PortalPageLayout";
import RawDataDeletePage from "../pages/ops/RawDataDeletePage";

const appRoutes: RouteType[] = [
  {
    element: <RegistrationPageLayout />,
    state: "registration",
    path: "/registration",
    sidebarProps: {
      displayText: "Registration",
      icon: <EditNoteTwoTone />
    },
    child: [
      {
        path: "/registration/register-base",
        element: <RegistrationPage />,
        state: "registration.basedata",
        sidebarProps: {
          displayText: "EEG Registration",
        },
      },
      {
        path: "/registration/register-ponton",
        element: <RegistrationPontonPage />,
        state: "registration.ponton",
        sidebarProps: {
          displayText: "Ponton Registration",
        }
      },
      {
        path: "/registration/accounts",
        element: <RegistrationAccountsPage />,
        state: "registration.accounts",
        sidebarProps: {
          displayText: "EEG Accounts",
        }
      },
    ]
  },
  {
    element: <PortalPageLayout/>,
    state: "portalManager",
    path: "/portal",
    sidebarProps: {
      displayText: "Portal Manager",
      icon: <ManageAccountsTwoTone/>
    },
  },
  {
    element: <RawDataDeletePage/>,
    state: "rawDataDelete",
    path: "/rawdata-delete",
    sidebarProps: {
      displayText: "Energiedaten löschen",
      icon: <DeleteForeverTwoTone/>
    },
  }
];

export default appRoutes;